// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobsTable th {
    border-bottom: 1px solid black;
    text-align: left;
}

.JobsTable tr {
    height: 40px;
}

.placeHolder {
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Unterlaeufe abgesetzt, damit die Zuordnung auf einen Blick erkennbar ist. Nur ein Hauch
   Hintergrund -- die Einrueckung traegt die Aussage, die Farbe unterstuetzt sie. */
.childRow {
    background-color: rgba(128, 128, 128, 0.07);
}

/* Die Einrueckungsmarke wird gezeichnet, nicht als Symbol geladen: Symbolnamen kommen zur
   Laufzeit aus einer Medienquelle, ein dort fehlender Name zeichnet stillschweigend nichts. */
.childArrow::before {
    content: "";
    width: 12px;
    height: 12px;
    margin-left: 14px;
    border-left: 1px solid currentColor;
    border-bottom: 1px solid currentColor;
    opacity: 0.35;
}

.jobName {
    font-weight: 500;
}

/* Die Lauf-ID steht klein unter dem Namen: Man braucht sie gelegentlich zum Nachsehen im
   Protokoll, aber sie darf den Namen nicht verdecken -- vorher stand an dieser Stelle
   ausschliesslich die ID. */
.jobRunID {
    font-size: 10px;
    opacity: 0.45;
    font-family: monospace;
    -webkit-user-select: all;
            user-select: all;
}

/* Die Kennzahl steht rechts in der Kopfzeile, abgesetzt vom Schalter links. */
.queueHeader {
    align-items: center;
    gap: 16px;
}

.serviceCounts {
    margin-left: auto;
    display: flex;
    gap: 12px;
    font-size: 12px;
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/jobs/queue/jobs.queue.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;mFACmF;AACnF;IACI,2CAA2C;AAC/C;;AAEA;8FAC8F;AAC9F;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;4BAE4B;AAC5B;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,wBAAgB;YAAhB,gBAAgB;AACpB;;AAEA,8EAA8E;AAC9E;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,eAAe;IACf,YAAY;AAChB","sourcesContent":[".JobsTable th {\n    border-bottom: 1px solid black;\n    text-align: left;\n}\n\n.JobsTable tr {\n    height: 40px;\n}\n\n.placeHolder {\n    width: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Unterlaeufe abgesetzt, damit die Zuordnung auf einen Blick erkennbar ist. Nur ein Hauch\n   Hintergrund -- die Einrueckung traegt die Aussage, die Farbe unterstuetzt sie. */\n.childRow {\n    background-color: rgba(128, 128, 128, 0.07);\n}\n\n/* Die Einrueckungsmarke wird gezeichnet, nicht als Symbol geladen: Symbolnamen kommen zur\n   Laufzeit aus einer Medienquelle, ein dort fehlender Name zeichnet stillschweigend nichts. */\n.childArrow::before {\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    margin-left: 14px;\n    border-left: 1px solid currentColor;\n    border-bottom: 1px solid currentColor;\n    opacity: 0.35;\n}\n\n.jobName {\n    font-weight: 500;\n}\n\n/* Die Lauf-ID steht klein unter dem Namen: Man braucht sie gelegentlich zum Nachsehen im\n   Protokoll, aber sie darf den Namen nicht verdecken -- vorher stand an dieser Stelle\n   ausschliesslich die ID. */\n.jobRunID {\n    font-size: 10px;\n    opacity: 0.45;\n    font-family: monospace;\n    user-select: all;\n}\n\n/* Die Kennzahl steht rechts in der Kopfzeile, abgesetzt vom Schalter links. */\n.queueHeader {\n    align-items: center;\n    gap: 16px;\n}\n\n.serviceCounts {\n    margin-left: auto;\n    display: flex;\n    gap: 12px;\n    font-size: 12px;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
